import React, { PureComponent } from 'react'
import { Field, reduxForm } from 'redux-form'
import { TextField } from 'redux-form-material-ui'
import { required } from '../form/validation'
import FlatButton from 'material-ui/FlatButton'
import Send from 'material-ui/svg-icons/content/send'
import { themeColors } from '../styles/theme'

const style = {
  marginTop: 0,
  marginBottom: 20,
  maxHeight: 200,
  overflowY: 'auto',
}

const footerStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  paddingTop: 8,
  height: 50,
  backgroundColor: themeColors.footergrey,
  zIndex: 1000,
}

class NewMessageForm extends PureComponent {
  render() {
    const {
      handleSubmit,
      submitting,
      submitSucceeded,
      label,
      onClose,
    } = this.props

    return (
      <form onSubmit={handleSubmit}>

        <div style={style}>
          <Field
            name="text"
            component={TextField}
            validate={required}
            disabled={submitting || submitSucceeded}
            hintText={label}
            floatingLabelText={label}
            multiLine={true}
            fullWidth={true}
            rows={2}
          />
        </div>
        <div style={footerStyle}>
          <FlatButton
            type="submit"
            disabled={submitting || submitSucceeded}
            label="Invia"
            primary={true}
            icon={<Send />}
            style={{ float: 'right', marginRight: 10, zIndex: 200000 }}
          />
          {onClose &&
            <FlatButton
              type="button"
              label="Annulla"
              secondary={true}
              onClick={onClose}
              style={{ float: 'left', marginLeft: 10, zIndex: 200000 }}
            />}
        </div>
      </form>
    )
  }
}

NewMessageForm.defaultProps = {
  label: 'Rispondi',
}

export default reduxForm({
  form: 'new-message-form',
})(NewMessageForm)



// WEBPACK FOOTER //
// ./src/common/NewMessageForm.js